module.exports = __webpack_public_path__ + "img/server_down.e9b88d89.svg";